module.exports = __webpack_public_path__ + "static/media/insect(37).d08eb6bd.PNG";